import Immutable from "immutable";
import RecordClassCreator from "services/record";
import Response from "../Response";

export default class ResponseSideBar extends RecordClassCreator({
  type: "responseSideBar",
  content: null,
  description: null,
  handle: null,
  responseId: null,
  blocks: null,
  reserved: false,
  messages: Immutable.Map(),

  source: Immutable.Map({
    buttonLabel: Immutable.Map(),
    canAddMessages: false,
    created: null,
    description: "",
    descriptiveString: "",
    handle: "",
    hasTraining: false,
    hasQuickReply: false,
    live: false,
    messages: Immutable.Map(),
    tags: Immutable.List(),
    reserved: false,
    reservedResponseType: null,
    reviewable: false,
    updated: null
  })
}) {
  // Getter not implemented. Add condition here to return Boolean.
  // If hasNewLabel is true, responses will have "NEW" label in response editor UI
  //
  // eslint-disable-next-line class-methods-use-this,require-jsdoc
  get hasNewLabel() {
    return false;
  }

  /**
   * @returns {Boolean}
   */
  get isValid() {
    return Boolean(this.handle);
  }

  /**
   * @returns {Immutable.List}
   */
  get languages() {
    return Immutable.List(this.messages.keys());
  }

  /**
   * @returns {Response}
   */
  get sourceResponse() {
    const attributes = this.source.toJS();

    return new Response(attributes);
  }

  /**
   * @returns {String}
   */
  static getFetchManyUrl() {
    return "/responses/filter";
  }

  /**
   *  // : {filter: {userinput: string}; page: number; sort: object}
   * @param {Object} params
   * @returns {Object}
   */
  static getFetchManyUrlParams(
    params
  ) {
    const { userinput } = params.filter;

    return {
      userinput,
      page: params.page,
      ...params.sort
    };
  }

  /**
   *
   * @param {String} id
   * @returns {String}
   */
  static getFetchOneUrl(id) {
    return `/responses/${id}`;
  }

  /**
   *  // : {response: {_type: string}}
   * @param {Object} payload
   * @returns {Object}
   */
  static resolveFetchOneResult(payload) {
    return {
      ...payload,
      data: {
        ...payload.response,
        reservedResponseType: payload.response._type
      }
    };
  }

  /**
   * : {responses: {_type: string}[]}
   * @param {Object} payload
   * @returns {Object}
   */
  static resolveFetchManyResult(payload) {
    return {
      ...payload,
      data: payload.responses.map(response => ({
        ...response,
        reservedResponseType: response._type
      }))
    };
  }
}
